import React, { useState } from 'react'
import { MdEdit } from 'react-icons/md'
import { toast } from 'react-toastify'
import { getAccessToken } from '../../services/authService'

// Click-to-rename script title. Saves the script's single title field (the same one the
// Title Page form edits), so there is never a second copy of the title.
const ScriptTitleEditor = ({ scriptId, title, canEdit, onSaved, className = '', textClassName = '', inputClassName = '' }) => {
    const [isRenaming, setIsRenaming] = useState(false)
    const [draft, setDraft] = useState('')
    const [isSaving, setIsSaving] = useState(false)

    const save = async () => {
        const next = draft.trim()
        if (next === (title || '')) { setIsRenaming(false); return }
        setIsSaving(true)
        try {
            const res = await fetch(`${process.env.REACT_APP_DEV_API}/document/${scriptId}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${getAccessToken()}` },
                // A blank name is turned into "Untitled Script N" by the server.
                body: JSON.stringify({ title: next })
            })
            const body = await res.json()
            if (!res.ok) throw new Error(body.message || 'Could not rename script')
            onSaved(body.data || { title: next })
            toast.success('Script renamed')
            setIsRenaming(false)
        } catch (error) {
            toast.error(error.message)
        } finally {
            setIsSaving(false)
        }
    }

    if (isRenaming) {
        return (
            <input
                autoFocus
                aria-label='Script title'
                value={draft}
                disabled={isSaving}
                onChange={(e) => setDraft(e.target.value)}
                onBlur={save}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') e.currentTarget.blur()
                    if (e.key === 'Escape') { setDraft(title || ''); setIsRenaming(false) }
                }}
                className={`font-bold text-[#292929] text-center border border-[#CACACA] rounded-lg px-2 py-1 ${inputClassName}`}
            />
        )
    }

    return (
        <h2
            title={canEdit ? 'Rename script' : undefined}
            onClick={() => { if (canEdit) { setDraft(title || ''); setIsRenaming(true) } }}
            className={`flex items-center justify-center gap-2 ${canEdit ? 'cursor-pointer' : ''} ${className}`}
        >
            <span className={textClassName}>{title}</span>
            {canEdit && <MdEdit size={16} color='#868686' aria-label='Rename script' className='shrink-0' />}
        </h2>
    )
}

export default ScriptTitleEditor
